import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import AppWithShell from './AppWithShell';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { ClerkProvider } from '@clerk/clerk-react';
import { initializeTheme } from './lib/theme';
import { ToastHost } from './components/shared/Toast';

// Initialize theme immediately to prevent flash
initializeTheme();

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  throw new Error("Missing Publishable Key");
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Lazy load heavier route components
const PricingPage = React.lazy(() => import('./pages/PricingPage'));
const SettingsPage = React.lazy(() => import('./pages/SettingsPage'));

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey} appearance={{ variables: { colorPrimary: '#2563eb' } }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppWithShell />} />
          <Route path="/v2" element={<Navigate to="/" replace />} />
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/pricing" element={
            <React.Suspense fallback={<div className="min-h-screen bg-background" />}>
              <PricingPage />
            </React.Suspense>
          } />
          <Route path="/settings" element={
            <React.Suspense fallback={<div className="min-h-screen bg-background" />}>
              <SettingsPage />
            </React.Suspense>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <ToastHost />
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
